"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardStatBlock = void 0;
var _react = require("react");
var _classVarianceAuthority = require("class-variance-authority");
var _helpers = require("../../common/helpers");
var _Container = require("../Container");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["cardsPerRow", "cardAlignment", "containerSize", "containerAlignment", "slots", "slotProps", "as", "className", "children"],
  _excluded2 = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var classesWrapper = (0, _classVarianceAuthority.cva)(['flex', 'flex-row', 'flex-wrap', 'gap-5'], {
  variants: {
    containerSize: {
      12: ['col-span-12'],
      10: ['col-span-12', 'lg:col-span-10'],
      8: ['col-span-12', 'lg:col-span-10', 'xl:col-span-8']
    },
    containerAlignment: {
      left: ['col-start-1'],
      center: ['col-start-1']
    },
    cardsPerRow: {
      2: ['[&>*]:w-grid-1', 'sm:[&>*]:w-grid-2'],
      3: ['[&>*]:w-grid-1', 'sm:[&>*]:w-grid-2', 'lg:[&>*]:w-grid-3'],
      4: ['[&>*]:w-grid-1', 'sm:[&>*]:w-grid-2', 'lg:[&>*]:w-grid-3', 'xl:[&>*]:w-grid-4']
    },
    cardAlignment: {
      left: ['justify-start'],
      center: ['justify-center']
    }
  },
  compoundVariants: [{
    containerSize: 10,
    containerAlignment: 'center',
    className: ['lg:col-start-2']
  }, {
    containerSize: 8,
    containerAlignment: 'center',
    className: ['lg:col-start-2', 'xl:col-start-3']
  }]
});

/**
 * Card Stat Block - [API](https://reimagined-adventure-37999z9.pages.github.io/?path=/docs/blocks-cardstatblock) | [DSM](https://sharphealthcare.notion.site/Card-stat-block-aeaad4b3411c46589e5607d43aacbd9a)
 *
 * @example
 *
 * <CardStatBlock cardsPerRow={3}>
 *   <CardStat ... />
 *   <CardStat ... />
 *   <CardStat ... />
 * </CardStatBlock>
 */
var CardStatBlock = exports.CardStatBlock = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _slots$container, _slotProps$container;
  var _props$cardsPerRow = props.cardsPerRow,
    cardsPerRow = _props$cardsPerRow === void 0 ? 3 : _props$cardsPerRow,
    _props$cardAlignment = props.cardAlignment,
    cardAlignment = _props$cardAlignment === void 0 ? 'left' : _props$cardAlignment,
    _props$containerSize = props.containerSize,
    containerSize = _props$containerSize === void 0 ? 12 : _props$containerSize,
    _props$containerAlign = props.containerAlignment,
    containerAlignment = _props$containerAlign === void 0 ? 'left' : _props$containerAlign,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    _props$slotProps = props.slotProps,
    slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
    as = props.as,
    className = props.className,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var Container = (_slots$container = slots.container) !== null && _slots$container !== void 0 ? _slots$container : 'div';
  var _ref = (_slotProps$container = slotProps.container) !== null && _slotProps$container !== void 0 ? _slotProps$container : {},
    containerClassName = _ref.className,
    containerProps = _objectWithoutProperties(_ref, _excluded2);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Container.Container, _objectSpread(_objectSpread({
    className: (0, _helpers.cn)('grid grid-cols-12', className)
  }, rest), {}, {
    as: as,
    ref: ref,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Container, _objectSpread(_objectSpread({
      className: (0, _helpers.cn)(classesWrapper({
        cardAlignment: cardAlignment,
        cardsPerRow: cardsPerRow,
        containerAlignment: containerAlignment,
        containerSize: containerSize
      }), containerClassName)
    }, containerProps), {}, {
      children: children
    }))
  }));
});